import { validator } from "@exodus/schemasafe";
import { mergeWith, update } from "lodash-es";

import { isEmpty } from "../utils/utils.js";

function validateJson(schema, instance) {
  let validate = validator(schema, {
    allErrors: true,
    includeErrors: true
  });

  let isValid = validate(instance);

  return { isValid: isValid, error: validate.errors };
}

// Define an action to update a nested value
const mergeValue = ({ oldValue, value, path = [] }) => {
  /**
   * Note: if path is empty then we need to update the whole value.
   *       We are merging the old and new value when user trying to update the whole Json value
   */
  if (isEmpty(path)) {
    // if target value is empty then we will reset the value to default value
    if (isEmpty(value)) return value;
    // if target value is not empty then we will merge the old and new value
    return mergeWith(oldValue, value, customizer);
  }

  // If path is not empty, we need to update the nested value
  return update(oldValue, path, () => value);
};

// Customizer function to replace the array value
function customizer(objValue, srcValue) {
  if (Array.isArray(objValue)) {
    return srcValue;
  }
}

export function validateJsonValue({ value, path, schema, oldValue }) {
  let newValue = mergeValue({ oldValue, value, path });

  let { isValid, error } = validateJson(schema, newValue);

  error = error?.map((e) => {
    return {
      // eslint-disable-next-line max-len
      message: `Validation encountered an error while validating the value with schema in the designated path (${e.instanceLocation}).
This issue arises from a type mismatch or other schema constraints.
We recommend reviewing both your schema and the provided value for resolution.`,
      ...e
    };
  });

  return { isValid, value: newValue, error };
}
